<script>
  import { getContext } from 'svelte'
  import { faLock, faEnvelope, faLink, faPhone, faSearch, faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons'

  import Icon from '../Icon/'
  import { cssPrefix } from '../helper-classes.js'

  export let variant = null
  export let config = {}
  export let id = null

  const element = getContext('currentElement')

  const layout = config.layout || getContext('formGroupLayout')
  if (layout === 'TwoCols') {
    config.blockClasses = [`${cssPrefix}form-block`, 'is-horizontal', 'has-control']
  } else {
    config.blockClasses = [`${cssPrefix}form-block`]
  }

  const variantIcons = {
    Email: faEnvelope,
    Password: faLock,
    Search: faSearch,
    Tel: faPhone,
    Url: faLink
  }

  const isPasswordField = variant === 'Password'
  let showPassword = false
  const togglePasswordVisibility = () => {
    showPassword = !showPassword
  }
  $: passwordIcon = showPassword ? faEyeSlash : faEye

  if (!config.iconStart && variantIcons[variant] && !config.noicon) config.iconStart = variantIcons[variant]

  const controlClasses = [`${cssPrefix}control`]
  if (config.iconStart && !config.noicon) controlClasses.push('has-icons-start')
  if ((config.iconEnd && !config.noicon) || config.textEnd) controlClasses.push('has-icons-end')
  if (isPasswordField) controlClasses.push('has-icons-end is-password-field')
</script>

<div class={config.blockClasses && config.blockClasses.join(' ')}>
  {#if $element.label}
    <div class={`${cssPrefix}form-label`}>
      <div class={`${cssPrefix}label`} class:is-required={$element.required && !$element.disabled}>
        <label for={id}>{$element.label}</label>
      </div>
    </div>
  {/if}

  <div class={`${cssPrefix}form-field`}>
    <div class={controlClasses.join(' ')} class:is-loading={$element.loading}>
      {#if config.iconStart && !config.noicon}
        <Icon icon={config.iconStart} iconClass="is-start" />
      {/if}

      <slot
        inputClass={$element.error || ($element.value && $element.value.length > $element.maxLength)
          ? `${cssPrefix}input has-error`
          : `${cssPrefix}input`}
      />

      {#if config.iconEnd && !config.noicon}
        <Icon icon={config.iconEnd} iconClass="is-end" />
      {:else if isPasswordField && !config.noicon}
        <div class={`${cssPrefix}icon is-end`}>
          <Icon
            icon={passwordIcon}
            iconClass={`is-end ${cssPrefix}tooltip`}
            tooltip={showPassword ? 'Hide password' : 'Show password'}
            style="width:150px"
            on:click={e => {
              togglePasswordVisibility()
              element.onEvent(e, 'show-password', showPassword)
            }}
          />
        </div>
      {:else if config.textEnd}
        <div class={`${cssPrefix}icon is-end color-disabled`}>{config.textEnd}</div>
      {/if}
    </div>
  </div>

  {#if $element.info}
    <div class={`${cssPrefix}form-info`} class:has-info={$element.info}>
      <div class={`${cssPrefix}message`}>
        <p id="${id}-description">{$element.info}</p>
      </div>
    </div>
  {/if}

  {#if $element.maxLength}
    <div class={`${cssPrefix}form-character-count my-2`}>
      <div
        class={`${cssPrefix}message`}
        class:is-status-error={$element.value && $element.value.length > $element.maxLength}
      >
        <p id="${id}-length">
          {config.characterCount ? config.characterCount : 'Character count'}:
          <span
            class:max-character={$element.value && $element.value.length === $element.maxLength}
            id="current-character-count"
          >
            {$element.value && $element.value.length ? $element.value.length : 0}
          </span>
          / {$element.maxLength}
        </p>
      </div>
    </div>
  {/if}

  {#if $element.error}
    <div class={`${cssPrefix}form-error`}>
      <div class={`${cssPrefix}message is-status-error`}>
        <p id="${id}-error">{$element.error}</p>
      </div>
    </div>
  {/if}
</div>
